module.exports = __webpack_public_path__ + "static/media/spark.82025e1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark.svg
// module id = 502
// module chunks = 0